module.exports = __webpack_public_path__ + "static/media/trivia-round4.6a578d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/trivia-round4.png
// module id = 2750
// module chunks = 0